import './bootstrap';
import HawkCatcher from '@hawk.so/browser';
import { createInertiaApp, type ResolvedComponent, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { hydrateRoot } from 'react-dom/client';
import { isProdEnv } from './utils/app-env';
import { networkErrorToast } from './utils/error-handler';
import _ym from './utils/yandex-metrika';

const APP_ID = import.meta.env.VITE_APP_ID;

/*
|--------------------------------------------------------------------------
| Setup Hawk error tracking
|--------------------------------------------------------------------------
*/
if (isProdEnv) {
    const hawk = new HawkCatcher({
        token: import.meta.env.VITE_HAWK_TOKEN || '',
    });

    hawk.setContext({
        feature: 'app',
        environment: import.meta.env.VITE_APP_ENV,
    });
}

/*
|--------------------------------------------------------------------------
| Setup Yandex Metrika & Google Analytics
|--------------------------------------------------------------------------
*/
router.on('navigate', () => {
    _ym('hit', window.location.href);
});

/*
|--------------------------------------------------------------------------
| Handle network error.
|--------------------------------------------------------------------------
*/
router.on('networkError', (event) => {
    event.preventDefault();
    networkErrorToast();
});

/*
|--------------------------------------------------------------------------
| Setup Inertia app
|--------------------------------------------------------------------------
*/
createInertiaApp({
    id: APP_ID,
    resolve: (name) =>
        resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob<ResolvedComponent>('./Pages/**/*.tsx')),
    setup({ el, App, props }) {
        hydrateRoot(el, <App {...props} />);
    },
    progress: {
        color: '#FF0000',
    },
}).then(() => {
    document.querySelector(`script[data-page="${APP_ID}"]`)?.remove();
});
